import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconTypes } from '../../../pencil-icon/pencil-icon.component';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from '../../../pencil-button/pencil-button.component';
import {
  GenericSplitScreenConfig,
  GenericSplitScreenModalComponent,
} from '../generic-split-screen-modal.component';

export interface SplitScreenModalConfig {
  submitButtonText: string;
  isSubmitDisabled: boolean;
  isLoading: boolean;
  showPreview: boolean;
  fullScreen?: boolean;
  formLoadingText: string;
  formLoadingSubtext: string;
}

@Component({
  selector: 'app-split-screen-form-based-modal',
  templateUrl: './split-screen-form-based-modal.component.html',
  styleUrls: ['./split-screen-form-based-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    PencilButtonComponent,
    MatProgressSpinnerModule,
    TranslateModule,
    GenericSplitScreenModalComponent,
  ],
})
export class SplitScreenFormBasedComponent {
  @Input() config: SplitScreenModalConfig = {
    submitButtonText: this.translateService.instant('Submit'),
    isSubmitDisabled: true,
    isLoading: false,
    showPreview: true,
    formLoadingText: this.translateService.instant('Loading...'),
    formLoadingSubtext: this.translateService.instant('Please wait'),
  };

  @Output() submitForm = new EventEmitter<void>();

  // Expose PencilButtonThemeEnum for template use
  PencilButtonThemeEnum = PencilButtonThemeEnum;
  IconTypes = IconTypes;

  constructor(private translateService: TranslateService) {}

  // Convert our config to generic config
  get genericConfig(): GenericSplitScreenConfig {
    return {
      showRightSection: this.config.showPreview,
      fullScreen: this.config.fullScreen,
    };
  }

  onSubmit(): void {
    if (!this.config.isSubmitDisabled && !this.config.isLoading) {
      this.submitForm.emit();
    }
  }

  // Prevent any accidental navigation or closing
  onKeyDown(event: KeyboardEvent): void {
    // Block escape key
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
